/**
 * Device Information Utility
 * Provides functions to gather information about the user's device and browser
 */

/**
 * Get browser information from user agent
 * @returns {string} Browser name
 */
export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  
  if (userAgent.match(/chrome|chromium|crios/i)) {
    return "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    return "Firefox";
  } else if (userAgent.match(/safari/i)) {
    return "Safari";
  } else if (userAgent.match(/opr\//i)) {
    return "Opera";
  } else if (userAgent.match(/edg/i)) {
    return "Edge";
  } else {
    return "Unknown";
  }
};

/**
 * Get device type from user agent
 * @returns {string} Device type (Mobile, Tablet, or Desktop)
 */
export const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return "Mobile";
  } else if (/iPad|Tablet|PlayBook/i.test(userAgent)) {
    return "Tablet";
  }
  
  return "Desktop";
};

/**
 * Get screen size category based on window width
 * @returns {string} Screen size category (xs, sm, md, lg, xl)
 */
export const getScreenSize = () => {
  const width = window.innerWidth;
  
  if (width < 576) {
    return "xs";
  } else if (width < 768) {
    return "sm";
  } else if (width < 992) {
    return "md";
  } else if (width < 1200) {
    return "lg";
  } else {
    return "xl";
  }
}; 